module.exports = __webpack_public_path__ + "img/no-notes-image.f4e5e1c0.svg";